import React, { useState, useMemo, useEffect, useRef } from "react";
import { Rating } from "react-simple-star-rating";
import productsliderimg from "../../src/assets/images/productsliderimg.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
import { faPlus, faEye, faFile } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import gridboxicon from "../assets/images/gridboxicon.svg";
import gridlisticon from "../assets/images/gridlisticon.svg";
import exportsvg from "../assets/images/dashboard/export.svg";
import filtersvg from "../assets/images/filter.svg";
import customer_table from "../assets/images/customer_table.svg";
import customer_edit from "../assets/images/customer_edit.svg";
import customer_delete from "../assets/images/customer_trash.svg";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../config/Config";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import * as XLSX from "xlsx";
import { useReactToPrint } from "react-to-print";

import JSZip from "jszip";
import { saveAs } from "file-saver";

import html2pdf from "html2pdf.js";

ModuleRegistry.registerModules([ClientSideRowModelModule, CsvExportModule]);

const Staff = () => {
  const answertypes = [
    { value: "textinput", label: "Text Input" },
    { value: "numberinput", label: "Number Input" },
    { value: "dropdown", label: "Dropdown" },
    { value: "multi-select-dropdown", label: "Multi Select Dropdown" },
    { value: "date", label: "Date" },
    { value: "multilinetext", label: "Multi-line Text" },
    { value: "image", label: "Image" },
  ];

  const imageincludedarr = [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" },
  ];
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);
  let navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [rowData, setRowData] = useState([]);
  const [showloding, setshowloding] = useState(false);
  const [tabletype, settabletype] = useState(
    userdata?.type == "superadmin" ? "questions" : "data"
  );
  const [showmodal, setshowmodal] = useState(false);
  const [selectedanswer, setselectedanswer] = useState("");
  const [question, setquestion] = useState("");
  const [isimageinclude, setisimageinclude] = useState("");
  const [tags, settags] = useState([]);

  const [showeditmodal, setshoweditmodal] = useState(false);
  const [selectedid, setselectedid] = useState(0);

  const [showdetailsmodal, setshowdetailsmodal] = useState(false);
  const [selectedrow, setselectedrow] = useState({});

  const [showeditdetailsmodal, setshoweditdetailsmodal] = useState(false);
  const [selectedrowid, setselectedrowid] = useState(0);
  const [selectededitrow, setselectededitrow] = useState([]);

  const selectedrowidRef = useRef(0);
  selectedrowidRef.current = selectedrowid;

  const selectededitrowRef = useRef(0);
  selectededitrowRef.current = selectededitrow;

  const selectedidref = useRef(null);
  selectedidref.current = selectedid;

  const selectedrowRef = useRef(null);
  selectedrowRef.current = selectedrow;

  const dispatch = useDispatch();

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState();

  const record = {
    "Capture Borrower photo_image":
      "https://fieldapp.consulthagnos.in.net/apibackend/assets/images/borrower/alMduMlX5baNXQFQ22ksPZMEFVzGsEg2.png",
    "Other Images_image":
      "https://fieldapp.consulthagnos.in.net/apibackend/assets/images/borrower/HxUKz4tbgvuLwqVbCX8w1XQ86etNYCU6.png",
    "Other images 2_image":
      "https://fieldapp.consulthagnos.in.net/apibackend/assets/images/borrower/q6dOVnMhZ8a4V0odCHmU5rRzedQgHkEl.png",
  };

  const downloadZip = async (selecteddata) => {
    var data = selecteddata;
    console.log("selecteddata >>", selecteddata);
    var keytsdata = Object.keys(selecteddata);
    var imagesobj = {};
    for (var i = 0; i < keytsdata?.length; i++) {
      var value = selecteddata[keytsdata[i]];
      if (typeof value === "string" && value.includes("https")) {
        imagesobj[keytsdata[i]] = value;
      }
    }
    console.log("imagesobj >>", imagesobj);
    const zip = new JSZip();
    const folder = zip.folder(
      selecteddata["Staff Name"] + "_" + selecteddata["Branch Name"]
    ); // Create a folder inside the zip

    const imageUrls = Object.values(imagesobj).filter((url) => url !== null);

    const fetchAndAddImage = async (url, index) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const fileName = `image_${index + 1}.png`;
        folder.file(fileName, blob);
      } catch (error) {
        console.error("Failed to fetch image:", url, error);
      }
    };

    await Promise.all(imageUrls.map(fetchAndAddImage));

    // Generate and trigger download
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(
        content,
        selecteddata["Staff Name"] + "_" + selecteddata["Branch Name"] + ".zip"
      );
    });
  };

  const handleDownload = (selectedobj) => {
    const opt = {
      margin: 0.5,
      filename:
        selectedobj["Staff Name"] + "_" + selectedobj["Branch Name"] + ".pdf",
      image: { type: "png", quality: 1 },
      html2canvas: { scale: 1, useCORS: true, scrollY: 0 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    const element = contentRef.current;

    // Wait for all images inside the element to load
    const images = element.querySelectorAll("img");
    const loadPromises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = img.onerror = resolve;
      });
    });
    setTimeout(() => {
      Promise.all(loadPromises).then(() => {
        html2pdf().from(element).set(opt).save();
      });
    }, 500);
  };

  const defaultColDef = {
    flex: 1,
  };

  const defaultColDef1 = {
    // flex: 1,
  };

  //data table
  const paginationPageSizeSelector1 = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);
  const [rowData1, setRowData1] = useState([]);
  const [colDefs1, setColDefs1] = useState();

  const [staffformdata, setstaffformdata] = useState([]);

  const [inputvaluechange, setinputvaluechange] = useState({});
  const [forceupdate, setforceupdate] = useState(false);

  const inputvaluechangeRef = useRef();
  inputvaluechangeRef.current = inputvaluechange;

  const staffformdataRef = useRef();
  staffformdataRef.current = staffformdata;

  const clickhandle = () => {
    // console.log('Mission Launched')
  };

  const handleupdateurlbtn = async (id, value) => {
    console.log("id >>", id);
    console.log("value >>", value);
    // console.log('productname >>', productname);
    // console.log('rowData >>', categoriesdataRef.current);

    if (value && value > 0) {
      const updatedArray = [...staffformdataRef.current];
      const targetIndex = updatedArray.findIndex((item) => item.formid == id);
      if (targetIndex > -1) {
        const [movedItem] = updatedArray.splice(targetIndex, 1);
        updatedArray.splice(value - 1, 0, movedItem);
      }
      // return updatedArray;
      console.log("updatedArray >>", updatedArray);

      setshowloding(false);
      var data = { data: updatedArray };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "orderstaffform", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            // setshowsavebutton(false);
            window.location.reload();
            // handlefetchdata();
            setshowloding(false);
          } else {
            if (res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} });
              navigate("/login");
            } else {
              alert(res.data.message);
            }
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      setshowloding(false);
    } else {
      alert("sort preference cannot be empty or less then 1");
    }
  };

  const handlechangeurl = (id, value) => {
    // console.log('id >>', id);
    // console.log('value >>', value);

    // console.log('value >>', value);
    var prevdata = inputvaluechangeRef.current;
    // prevdata[id] = value;

    if (prevdata[id]) {
      // console.log('found >>', prevdata[id]);
      prevdata[id] = value;
    } else {
      // console.log('not found >>', prevdata[id]);
      prevdata[id] = value;
    }
    console.log("prevdata >>", prevdata);
    setinputvaluechange(prevdata);
    setforceupdate(!forceupdate);
  };

  const divRef = useRef();

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const handleviewdetails = (data) => {
    console.log("data >>", data);
    setselectedid(data?.formid);
    setquestion(data?.question);
    var answertypeobj = { value: data?.answertype, label: data?.answertype };
    setselectedanswer(answertypeobj);
    var isimageincludedobj = {
      value: data?.imageIncluded,
      label: data?.imageIncluded,
    };
    setisimageinclude(isimageincludedobj);
    if (
      data?.answertype == "dropdown" ||
      data?.answertype == "multi-select-dropdown"
    ) {
      if (data?.dropdown_data) {
        var tagsdata = data?.dropdown_data;
        try {
          settags(JSON.parse(tagsdata));
        } catch {
          settags([]);
        }
      } else {
        settags([]);
      }
    } else {
      settags([]);
    }
    setshoweditmodal(true);
  };

  const handleCheckboxChange = async (t, id) => {
    // console.log('t >>', t.target.checked);
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      id: id,
      status: t.target.checked ? "true" : "false",
    };
    let resp = await axios
      .post(apiUrl + "updatestaffformstatus", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          handlefetchdata();
          setshowloding(false);
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            alert(res.data.message);
          }
        }
      })
      .catch((err) => {
        alert(err.message);
      });
    setshowloding(false);
    // console.log('data >>', data);
  };

  const handlefetchdata = async () => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .get(apiUrl + "getallstaffforms", headers)
      .then((res) => {
        // console.log('res >>', res.data)
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;
          setstaffformdata(res?.data?.data);
          if (prevdata?.length > 0) {
            var columnsarr = [];
            var hidecolumns = [
              "userid",
              "updated_at",
              "created_at",
              "formid",
              "status",
              "dropdown_data",
              "orderby",
            ];
            var hidefilters = [];
            var columns = Object.keys(prevdata[0]);
            for (var i = 0; i < columns?.length; i++) {
              if (!hidecolumns.includes(columns[i])) {
                if (columns[i] == "name") {
                } else {
                  var obj = {};
                  obj.field = columns[i];
                  obj.cellStyle = { color: "#000", fontWeight: 600 };
                  if (!hidefilters.includes(columns[i])) {
                    obj.cellClass = "inventorycell";
                    obj.filter = true;
                    obj.filterParams = {
                      filterOptions: ["contains"],
                      maxNumConditions: 1,
                    };
                  }
                  //   console.log('obj >>', obj)
                  columnsarr.push(obj);
                }
              }
            }

            //action
            var statusobj = {
              field: "status",
              headerName: "Status",
              cellRenderer: (props) => {
                // console.log('props >>', props?.data)
                return (
                  <div className="d-flex">
                    <div class="form-check">
                      <input
                        onChange={(t) => {
                          handleCheckboxChange(t, props?.data?.formid);
                        }}
                        type="checkbox"
                        class="form-check-input tableformcheck"
                        id="check1"
                        name="option1"
                        value="something"
                        checked={
                          props?.data?.status == "true" ||
                          props?.data?.status == true
                            ? true
                            : false
                        }
                      />
                    </div>
                  </div>
                );
              },
            };
            columnsarr.push(statusobj);

            //sort obj
            var sortobj = {
              field: "sort",
              headerName: "Sort",
              // filter : true,
              // filterParams : {
              //         filterOptions: ["contains"],
              //         maxNumConditions: 1,
              //       },
              cellRenderer: (props) => {
                return (
                  // <div className="displayedittable">
                  // <p>{props.data.sortid}</p>
                  // </div>
                  <div className="admintrackingdiv">
                    <div className="admintrackingbox">
                      <input
                        type="number"
                        min={1}
                        defaultValue={
                          Object.keys(inputvaluechangeRef.current)?.length > 0
                            ? inputvaluechangeRef.current[props?.data?.formid]
                            : props?.data?.orderby
                        }
                        value={null}
                        onChange={(t) => {
                          handlechangeurl(props?.data?.formid, t.target.value);
                        }}
                        className="form-control admininput admintableinput"
                      />
                      <button
                        className="btn btn-primary updateurlbtn"
                        onClick={() => {
                          handleupdateurlbtn(
                            props?.data?.formid,
                            inputvaluechangeRef.current[props?.data?.formid]
                          );
                        }}
                      >
                        Sort
                      </button>
                    </div>
                  </div>
                );
              },
              cellRendererParams: {
                onClick: clickhandle,
              },
              width: 300,
            };
            columnsarr.push(sortobj);

            //action
            var actionobj = {
              field: "action",
              headerName: "Action",
              cellRenderer: (props) => {
                // console.log('props >>', props?.data)
                return (
                  <div className="d-flex">
                    <div
                      className="customet_table_icon_div"
                      onClick={() => {
                        handleviewdetails(props?.data);
                      }}
                    >
                      <img
                        src={customer_edit}
                        className="customet_table_icon"
                      />
                    </div>
                    {/* <div className="customet_table_icon_div">
                    <img src={customer_delete} className="customet_table_icon" />
                </div> */}
                  </div>
                );
              },
            };
            columnsarr.push(actionobj);

            setColDefs(columnsarr);
            setRowData(prevdata);
          } else {
            setColDefs([]);
            setRowData([]);
          }
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            alert(res.data.message);
          }
        }
      })
      .catch((err) => {
        alert(err.message);
      });

    setshowloding(false);
  };

  const handlesubmitquestion = async () => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      question: question,
      answertype: selectedanswer && selectedanswer?.value,
      is_image_included:
        (selectedanswer && selectedanswer?.value == "dropdown") ||
        selectedanswer?.value == "multi-select-dropdown"
          ? isimageinclude?.value
          : selectedanswer?.value == "image"
          ? "yes"
          : "no",
      dropdown_data:
        (selectedanswer && selectedanswer?.value == "dropdown") ||
        selectedanswer?.value == "multi-select-dropdown"
          ? tags
          : null,
      is_required: "no",
      is_unique: "no",
      status: "true",
    };
    let resp = await axios
      .post(apiUrl + "createstaffquestion", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          handlefetchdata();
          setshowmodal(false);
          setquestion("");
          setselectedanswer("");
          setisimageinclude("");
          settags([]);
          setshowloding(false);
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            alert(res.data.message);
          }
        }
      })
      .catch((err) => {
        alert(err.message);
      });
    setshowloding(false);
  };

  const handleupdatequestion = async () => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      id: selectedidref?.current,
      question: question,
      answertype: selectedanswer && selectedanswer?.value,
      is_image_included:
        (selectedanswer && selectedanswer?.value == "dropdown") ||
        selectedanswer?.value == "multi-select-dropdown"
          ? isimageinclude?.value
          : selectedanswer?.value == "image"
          ? "yes"
          : "no",
      dropdown_data:
        (selectedanswer && selectedanswer?.value == "dropdown") ||
        selectedanswer?.value == "multi-select-dropdown"
          ? tags
          : null,
    };
    console.log("updatestaffquestion data >>>", data);
    let resp = await axios
      .post(apiUrl + "updatestaffquestion", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          handlefetchdata();
          setshoweditmodal(false);
          setselectedid(0);
          setquestion("");
          setselectedanswer("");
          setisimageinclude("");
          settags([]);
          setshowloding(false);
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            alert(res.data.message);
          }
        }
      })
      .catch((err) => {
        alert(err.message);
      });
    setshowloding(false);
  };

  const newproductclick = () => {
    //   navigate('/add-internal-user')
    setselectedid(0);
    setquestion("");
    setselectedanswer("");
    setisimageinclude("");
    settags([]);
    setshowmodal(true);
  };

  const users = {
    user1: [
      { columnid: 1, name: "firstname", value: "Kiran" },
      { columnid: 2, name: "lastname", value: "Nandi" },
      { columnid: 3, name: "email", value: "kirannandi0303@gmail.com" },
      { columnid: 4, name: "number", value: "7666631996" },
    ],
    user2: [
      { columnid: 1, name: "firstname", value: "Siva" },
      { columnid: 2, name: "lastname", value: "Teja" },
      { columnid: 3, name: "email", value: "sivateja@gmail.com" },
      { columnid: 4, name: "number", value: "7666631996" },
    ],
    user3: [
      { columnid: 1, name: "firstname", value: "Sohail" },
      { columnid: 2, name: "lastname", value: "Mohd" },
      { columnid: 3, name: "email", value: "sohail@gmail.com" },
      { columnid: 4, name: "number", value: "7666631996" },
    ],
  };

  const handlefetchfilleddata = async () => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .get(apiUrl + "getallstafffilleddata", headers)
      .then((res) => {
        // console.log('res >>', res.data)
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;
          // console.log('prevdata >>', prevdata[0]);
          if (prevdata?.length > 0) {
            console.log("prevdata >>", prevdata[0]?.data);
            var columnsarr = [];
            var hidecolumns = [
              "userid",
              "updated_at",
              "created_at",
              "formid",
              "status",
              "dropdown_data",
            ];
            var hidefilters = [];

            // console.log('Object.values(users) >>', Object.values(users));

            // const columnsMap = Object.values(users).flat().reduce((acc, col) => {
            //   if (!acc[col.columnid]) {
            //     acc[col.columnid] = col.name; // Use columnid to map dynamic names
            //   }
            //   return acc;
            // }, {});

            // console.log('columnsMap >>', columnsMap)

            var parsedprevdata = JSON.parse(prevdata[0]?.data);
            const columnsMap1 = new Map();
            Object.values(parsedprevdata)
              .flat()
              .forEach((col) => {
                if (!columnsMap1.has(col.id)) {
                  columnsMap1.set(col.id, col.question); // Map columnid to dynamic name
                }
              });

            console.log("columnsMap1 >>", columnsMap1);

            // Define dynamic column definitions
            // const columnDefs = Object.keys(columnsMap).map((columnid) => ({
            //   headerName: columnsMap[columnid], // Dynamic name from columnid
            //   field: `column_${columnid}`,     // Dynamic field mapping
            // }));

            // Define dynamic column definitions
            const columnDefs1 = [
              { headerName: "userid", field: "user" },
              ...Array.from(columnsMap1.entries()).map(([id, question]) => ({
                headerName: question, // Dynamic name from Map
                field: `column_${id}`, // Unique field mapping
              })),
            ];

            console.log("columnDefs1 >>", columnDefs1);

            setColDefs1(columnDefs1);

            // Transform users into rows dynamically
            // const rowData = Object.values(users).map((user) => {
            //   console.log('rowData user >>', user);
            //   const row = {};
            //   user.forEach(({ columnid, value }) => {
            //     row[`column_${columnid}`] = value; // Map columnid to the value dynamically
            //   });
            //   return row;
            // });

            // console.log('rowData >>', rowData);

            const rowData1 = Object.entries(prevdata).map(([userid, user]) => {
              const row = { user: userid };
              var parseuser = JSON.parse(user?.data);
              console.log("parseuser user >>", parseuser);
              parseuser?.forEach(({ id, value }) => {
                row[`column_${id}`] = value; // Map columnid to the value dynamically
              });
              console.log("rowData1 row >>", row);
              return row;
            });

            setRowData1(rowData1);
          } else {
          }
          // if (prevdata?.length > 0) {
          //   var columnsarr = [];
          //   var hidecolumns = ["userid", "updated_at", "created_at", "formid", "status", "dropdown_data"];
          //   var hidefilters = [];
          //   var columns = Object.keys(prevdata[0]);
          //   for (var i = 0; i < columns?.length; i++) {
          //     if (!hidecolumns.includes(columns[i])) {
          //       if (columns[i] == "name") {

          //       } else {
          //         var obj = {};
          //         obj.field = columns[i];
          //         obj.cellStyle = { color: "#000", fontWeight: 600 };
          //         if (!hidefilters.includes(columns[i])) {
          //           obj.cellClass = "inventorycell";
          //           obj.filter = true;
          //           obj.filterParams = {
          //             filterOptions: ["contains"],
          //             maxNumConditions: 1,
          //           };
          //         }
          //         //   console.log('obj >>', obj)
          //         columnsarr.push(obj);
          //       }
          //     }
          //   }

          //    //action
          //    var statusobj = {
          //     field: "status",
          //     headerName: "Status",
          //     cellRenderer: (props) => {
          //       // console.log('props >>', props?.data)
          //       return (
          //         <div className="d-flex">
          //           <div class="form-check">
          //             <input
          //             onChange={(t) => {handleCheckboxChange(t, props?.data?.formid)}}
          //               type="checkbox"
          //               class="form-check-input tableformcheck"
          //               id="check1"
          //               name="option1"
          //               value="something"
          //               checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
          //             />
          //           </div>
          //         </div>
          //       );
          //     },
          //   };
          //   columnsarr.push(statusobj);

          //   //action
          //   var actionobj = {
          //     field: "action",
          //     headerName: "Action",
          //     cellRenderer: (props) => {
          //       // console.log('props >>', props?.data)
          //       return (
          //         <div className="d-flex">
          //           <div
          //             className="customet_table_icon_div"
          //             onClick={() => {
          //               handleviewdetails(props?.data);
          //             }}
          //           >
          //             <img
          //               src={customer_edit}
          //               className="customet_table_icon"
          //             />
          //           </div>
          //           {/* <div className="customet_table_icon_div">
          //           <img src={customer_delete} className="customet_table_icon" />
          //       </div> */}
          //         </div>
          //       );
          //     },
          //   };
          //   columnsarr.push(actionobj);

          //   setColDefs(columnsarr);
          //   setRowData(prevdata);
          // }
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            alert(res.data.message);
          }
        }
      })
      .catch((err) => {
        alert(err.message);
      });

    setshowloding(false);
  };

  const checkLastSixCharacters = (str) => {
    // Check if the string has at least 6 characters
    if (str.length < 6) {
      return false;
    }

    // Extract the last 6 characters
    const lastSix = str.slice(-6);

    // Check if the last 6 characters are "_image"
    return lastSix === "_image";
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };

  const handlefetchfilleddata1 = async () => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .get(apiUrl + "getallstafffilleddatav1", headers)
      .then((res) => {
        // console.log('res >>', res.data)
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;
          if (prevdata?.length > 0) {
            var columnsarr = [];
            var hidecolumns = [
              "userid",
              "updated_at",
              "created_at",
              "formid",
              "status",
              "dropdown_data",
              "rowid",
            ];
            var hidefilters = [];
            var columns = Object.keys(prevdata[0]);
            for (var i = 0; i < columns?.length; i++) {
              if (!hidecolumns.includes(columns[i])) {
                if (!checkLastSixCharacters(columns[i])) {
                  var obj = {};
                  obj.field = columns[i];
                  obj.headerName = columns[i].replace(/,/g, " ");
                  obj.cellStyle = { color: "#000", fontWeight: 600 };

                  if (!hidefilters.includes(columns[i])) {
                    obj.cellClass = "inventorycell";
                    if (columns[i] == "Created Date") {
                      obj.filter = "agDateColumnFilter";
                      // obj.filterValueGetter = (params) => {
                      //   return parseDate(params.data["Created Date"]);
                      // }
                      obj.comparator = (valueA, valueB) => {
                        const dateA = parseDate(valueA);
                        const dateB = parseDate(valueB);
                        return dateA - dateB; // Ascending order sorting
                      };
                    } else {
                      obj.filter = true;
                      obj.filterParams = {
                        filterOptions: ["contains"],
                        maxNumConditions: 1,
                      };
                    }
                  }
                  //   console.log('obj >>', obj)

                  columnsarr.push(obj);
                } else {
                  var obj = {};
                  obj.field = columns[i];
                  obj.headerName = columns[i].replace(/,/g, " ");
                  obj.cellStyle = { color: "#000", fontWeight: 600 };
                  obj.cellClass = "inventorycell";
                  obj.filter = true;
                  obj.filterParams = {
                    filterOptions: ["contains"],
                    maxNumConditions: 1,
                  };
                  obj.cellRenderer = (props) => {
                    // console.log('image props >>', props?.value);
                    return (
                      <>
                        {props?.value ? (
                          <Link
                            to={props?.value}
                            target="_blank"
                            className="tableviewimagediv"
                          >
                            <FontAwesomeIcon
                              icon={faImage}
                              fontSize={19}
                              style={{
                                color: "#64748B",
                                marginLeft: 15,
                                cursor: "pointer",
                              }}
                            />
                          </Link>
                        ) : (
                          <p></p>
                        )}
                      </>
                    );
                  };
                  //   console.log('obj >>', obj)
                  columnsarr.push(obj);
                }
              }
            }

            //  action
            //  var statusobj = {
            //   field: "status",
            //   headerName: "Status",
            //   minWidth: 200,
            //   cellRenderer: (props) => {
            //     // console.log('props >>', props?.data)
            //     return (
            //       <div className="d-flex">
            //         <div class="form-check">
            //           <input
            //           onChange={(t) => {handleCheckboxChange(t, props?.data?.formid)}}
            //             type="checkbox"
            //             class="form-check-input tableformcheck"
            //             id="check1"
            //             name="option1"
            //             value="something"
            //             checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
            //           />
            //         </div>
            //       </div>
            //     );
            //   },
            // };
            // columnsarr.push(statusobj);

            // action
            var actionobj = {
              field: "action",
              headerName: "Action",
              minWidth: 200,
              cellRenderer: (props) => {
                // console.log('status props >>', props?.data)

                return (
                  <div className="d-flex">
                    <div
                      className="customet_table_icon_div"
                      onClick={() => {
                        setselectedrow(props?.data);
                        setshowdetailsmodal(true);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faFile}
                        className="iconstyles"
                        style={{
                          color: "#64748B",
                          fontSize: 19,
                          marginRight: 20,
                          top: 4,
                          position: "relative",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <div
                      className="customet_table_icon_div ml-3"
                      onClick={() => {
                        // setselectedrow(props?.data);
                        // setshowdetailsmodal(true);
                        handleeditdetailsfunc(props?.data);
                      }}
                    >
                      <img
                        src={customer_edit}
                        className="customet_table_icon"
                      />
                    </div>
                    {/* <div className="customet_table_icon_div">
                  <img src={customer_delete} className="customet_table_icon" />
              </div> */}
                  </div>
                );
              },
            };
            columnsarr.push(actionobj);

            setColDefs1(columnsarr);
            setRowData1(prevdata);
          } else {
            setColDefs1([]);
            setRowData1([]);
          }
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            alert(res.data.message);
          }
        }
      })
      .catch((err) => {
        alert(err.message);
      });

    setshowloding(false);
  };

  const handlehiderowdetails = () => {
    setselectedrow({});
    setshowdetailsmodal(false);
  };

  const handleeditdetailsfunc = (data) => {
    console.log("data >>", data);
    console.log("staffformdata >>", staffformdata);
    // setselectededitrow
    if (staffformdata?.length > 0) {
      setselectedrowid(data?.rowid);
      setshoweditdetailsmodal(true);
      var prevdata = staffformdata;
      var newarr = [];
      for (var i = 0; i < prevdata?.length; i++) {
        var obj = prevdata[i];
        obj["value"] = data[prevdata[i]["question"]]
          ? data[prevdata[i]["question"]]
          : "";

        try {
          obj["imagefile"] =
            data[prevdata[i]["question"] + "_image"].slice(0, 4) === "http"
              ? data[prevdata[i]["question"] + "_image"]
              : null;
        } catch {}
        // console.log('obj >>', obj);
        newarr.push(obj);
      }
      setselectededitrow(newarr);
    }
  };

  const handlehideroweditdetails = () => {
    setshoweditdetailsmodal(false);
  };

  const handlechangeeditdetails = (index, val) => {
    var prevdata = selectededitrowRef.current;
    prevdata[index]["value"] = val;
    setselectededitrow(prevdata);
    setforceupdate(!forceupdate);
  };

  const MultiselctedDropdowncomp = ({value, dropdowndata, index}) => {
    var dropdowndataarr = [];
    var prevdata = JSON.parse(dropdowndata);
    for(var i = 0; i < prevdata?.length; i++) {
      var obj = {label: prevdata[i], value: prevdata[i]};
      dropdowndataarr.push(obj);
    }

    var valuearr = [];
    var prevvaluearr = value.length > 0 ? value.split(',') : [];
    if(prevvaluearr?.length > 0) {
      for(var i = 0; i < prevvaluearr?.length; i++) {
        var obj = {value: prevvaluearr[i], label: prevvaluearr[i]}
        valuearr.push(obj)
      }
    } else {
      valuearr = ""
    }

    const handlechangemultiinput = (data) => {
      // console.log('handlechangemultiinput data >>', data);
      var datavaluearr = [];
      for(var i = 0; i < data?.length; i++) {
        datavaluearr.push(data[i].value);
      }
      handlechangeeditdetails(index, datavaluearr.join(','))
    }

    return (
      <Select
                isMulti
                closeMenuOnSelect={false}
                value={valuearr}
                onChange={handlechangemultiinput}
                options={dropdowndataarr}
                className="offerselectdropdown"
              />
    )
  }

  const handlesubmiteditdestails = async() => {
    var prevdata = selectededitrowRef.current;
    console.log('prevdata >>', prevdata);
    var dataobj = {};
    for(var i = 0; i < prevdata?.length; i++) {
      dataobj[prevdata[i]['formid']] = {question: prevdata[i]['question'], value: prevdata[i]['value'], imagefile: prevdata[i]['imagefile'] ? prevdata[i]['imagefile'] : null};
    }
    var data = {
      id: selectedrowidRef.current,
      data: dataobj
    }

    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "staffformeditbyadmin", data, headers)
      .then((res) => {
        // console.log('res >>>', res.data)
        if (res.data.status == "success") {
          // setshowsavebutton(false);
          // window.location.reload();
          setselectededitrow([]);
          setselectedrowid(0);
          setshoweditdetailsmodal(false);
          handlefetchfilleddata1();
          // handlefetchdata();
          setshowloding(false);
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            alert(res.data.message);
          }
          setshowloding(false);
        }
      })
      .catch((err) => {
        setshowloding(false);
        alert(err.message);
      });

  }

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleuploadeditimg =async(index, file) => {
    var obj = {};
    await getBase64(file).then(async(result) => {
      obj["name"] = file.name;
      obj["image"] = result;
      const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: "Bearer " + userdata?.token,
          },
      }
    var data = {
      imagefile : result.split(',')[1]
    } 

    await axios.post(apiUrl+'staffuploadimg',data, config).then((resp) => {
      // setloading(false);
      // console.log('res.data >>', resp.data)
      // console.log('res >>>', res.data)
      if (resp.data.status == "success") {
        // setshowsavebutton(false);
        // window.location.reload();
        // handlefetchdata();
        if(resp.data.message == 'Image uploaded successfully') {
          // handlechangeeditdetails(index, resp?.data?.imageurl);
          var prevdata = selectededitrowRef.current;
          prevdata[index]["imagefile"] = resp?.data?.imageurl;
          setselectededitrow(prevdata);
          setforceupdate(!forceupdate);
        } else {

        }
        // setshowloding(false);
      } else {
        if (resp.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} });
          navigate("/login");
        } else {
          alert(resp.data.message);
        }
        setshowloding(false);
      }
    }).catch((err) => {
      console.log('err1 >>', err);
      // setloading(false);
    });
    });
    // setcategoryimage(obj);
  }

  const gridRef = React.useRef(null);

  const getCurrentDate = () => {
    const date = new Date();

    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if single digit
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so we add 1
    const year = date.getFullYear();

    return `${day}_${month}_${year}`;
  };

  const handleexportclicked = () => {
    if (gridRef.current) {
      //   gridRef.current.api.exportDataAsCsv({
      //     fileName: "MyExcelExport.xls",
      // });
      const api = gridRef.current.api;

      // Use the API to export data as CSV
      const csvData = api.getDataAsCsv();

      // Convert CSV data to an array of arrays and clean up quotes
      const dataArray = csvData.split("\n").map((row) => {
        return row.split(",").map((cell) => cell.replace(/^"(.*)"$/, "$1")); // Remove quotes from start and end
      });

      // Convert the cleaned data to a worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(dataArray);

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Save the file as an Excel (.xlsx)
      XLSX.writeFile(workbook, "staff_data_" + getCurrentDate() + ".xlsx");
    } else {
      console.error("Grid is not initialized yet.");
    }
  };

  useEffect(() => {
    if (tabletype == "questions") {
      handlefetchdata();
    } else {
      handlefetchfilleddata1();
    }
  }, [tabletype]);

  useEffect(() => {
    if (userdata && Object.keys(userdata).length > 0) {
      // handlefetchdata();
      // handlefetchfilleddata1();
    } else {
      navigate("/login");
    }
  }, []);

  return (
    <div className="">
      <div className="dashboardbox" style={{ width: "100%" }}>
        <div className="productstogglebar mt-2">
          <div>
            {/* <select
              value={tabletype}
              onChange={(t) => {
                settabletype(t.target.value);
              }}
              className="dashboard-deals-dropdown form-control addproductinput"
              style={{ marginTop: 0 }}
            >
              <option disabled>Select Table</option>
              <option value="questions">Questions</option>
              <option value="data">Data</option>
            </select> */}
          </div>
          {userdata?.type == "superadmin" ? (
            <div
              className={
                tabletype == "questions"
                  ? "filterdiv couponfilterdiv questiondiv active"
                  : "filterdiv couponfilterdiv questiondiv"
              }
              onClick={() => {
                settabletype("questions");
              }}
              style={{ marginLeft: 0, marginRight: 15 }}
            >
              <p>Form</p>
            </div>
          ) : null}

          <div
            className={
              tabletype == "data"
                ? "filterdiv couponfilterdiv questiondiv active"
                : "filterdiv couponfilterdiv questiondiv"
            }
            onClick={() => {
              settabletype("data");
            }}
            style={{ marginLeft: 0 }}
          >
            <p>Data</p>
          </div>
          {tabletype == "questions" ? (
            <div
              className="filterdiv couponfilterdiv"
              onClick={newproductclick}
            >
              <FontAwesomeIcon
                icon={faPlus}
                className="iconstyles"
                style={{ color: "#64748B" }}
              />
              <p>Add Question</p>
            </div>
          ) : (
            <div
              className="filterdiv couponfilterdiv"
              onClick={() => {
                handleexportclicked();
              }}
            >
              <img src={exportsvg} className="orderexporticon" />
              <p>Exports</p>
            </div>
          )}
        </div>
        {tabletype == "questions" ? (
          <div
            className={"ag-theme-quartz mt-4"}
            style={{ width: "100%", height: 550 }}
          >
            <AgGridReact
              // modules={AllModules}

              rowData={rowData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              suppressRowClickSelection={true}
              groupSelectsChildren={true}
              rowSelection={"multiple"}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={paginationPageSizeSelector}
              rowHeight={50}
              // onGridReady={onGridReady}
            />
          </div>
        ) : (
          <div
            className={"ag-theme-quartz mt-4"}
            style={{ width: "100%", height: 550 }}
          >
            <AgGridReact
              // modules={AllModules}
              ref={gridRef}
              rowData={rowData1}
              columnDefs={colDefs1}
              defaultColDef={defaultColDef1}
              suppressRowClickSelection={true}
              groupSelectsChildren={true}
              //  rowSelection={"multiple"}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={paginationPageSizeSelector1}
              rowHeight={50}
              // onGridReady={onGridReady}
            />
          </div>
        )}
      </div>

      {/*Add modal */}
      <Modal
        show={showmodal}
        onHide={() => setshowmodal(false)}
        size="md"
        className="custom-width-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 19 }}>New Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div className="row">
              <div className="col-md-12">
                <label className="mb-2">Question</label>
                <input
                  value={question}
                  onChange={(t) => {
                    setquestion(t.target.value);
                  }}
                  className="form-control "
                  placeholder="Enter Question"
                  style={{ height: 45 }}
                />
              </div>
              <div className="col-md-12 mt-3">
                <label className="mb-2">Answer Type</label>
                <Select
                  value={selectedanswer}
                  onChange={setselectedanswer}
                  options={answertypes}
                  style={{ height: 45 }}
                />
              </div>
              {(selectedanswer && selectedanswer?.value == "dropdown") ||
              selectedanswer?.value == "multi-select-dropdown" ? (
                <div className="col-md-12 mt-3">
                  <label className="mb-2">
                    Is Image included for this answer
                  </label>
                  <Select
                    value={isimageinclude}
                    onChange={setisimageinclude}
                    options={imageincludedarr}
                    style={{ height: 45 }}
                  />
                </div>
              ) : null}

              {(selectedanswer && selectedanswer?.value == "dropdown") ||
              selectedanswer?.value == "multi-select-dropdown" ? (
                <div className="col-md-12 mt-3">
                  <label className="mb-2">
                    Enter dropdown values (Type value and press enter to add
                    another value)
                  </label>
                  <TagsInput
                    value={tags}
                    onChange={(options) => {
                      settags(options);
                    }}
                    inputProps={{
                      className: "react-tagsinput-input",
                      placeholder: "",
                    }}
                    className="form-control tagsinputbox"
                  />
                </div>
              ) : null}

              <div className="col-md-12 mt-3">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    handlesubmitquestion();
                  }}
                >
                  <p>Submit</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*Edit modal */}
      <Modal
        show={showeditmodal}
        onHide={() => setshoweditmodal(false)}
        size="md"
        className="custom-width-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 19 }}>Update Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div className="row">
              <div className="col-md-12">
                <label className="mb-2">Question</label>
                <input
                  value={question}
                  onChange={(t) => {
                    setquestion(t.target.value);
                  }}
                  className="form-control "
                  placeholder="Enter Question"
                  style={{ height: 45 }}
                />
              </div>
              <div className="col-md-12 mt-3">
                <label className="mb-2">Answer Type</label>
                <Select
                  value={selectedanswer}
                  onChange={setselectedanswer}
                  options={answertypes}
                  style={{ height: 45 }}
                />
              </div>
              {(selectedanswer && selectedanswer?.value == "dropdown") ||
              selectedanswer?.value == "multi-select-dropdown" ? (
                <div className="col-md-12 mt-3">
                  <label className="mb-2">
                    Is Image included for this answer
                  </label>
                  <Select
                    value={isimageinclude}
                    onChange={setisimageinclude}
                    options={imageincludedarr}
                    style={{ height: 45 }}
                  />
                </div>
              ) : null}

              {(selectedanswer && selectedanswer?.value == "dropdown") ||
              selectedanswer?.value == "multi-select-dropdown" ? (
                <div className="col-md-12 mt-3">
                  <label className="mb-2">
                    Enter dropdown values (Type value and press enter to add
                    another value)
                  </label>
                  <TagsInput
                    value={tags}
                    onChange={(options) => {
                      settags(options);
                    }}
                    inputProps={{
                      className: "react-tagsinput-input",
                      placeholder: "",
                    }}
                    className="form-control tagsinputbox"
                  />
                </div>
              ) : null}

              <div className="col-md-12 mt-3">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    handleupdatequestion();
                  }}
                >
                  <p>Update</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Details Modal */}
      <Modal
        show={showdetailsmodal}
        onHide={() => {
          handlehiderowdetails();
        }}
        size="lg"
        className="custom-width-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 19 }}>Staff Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div className="row" style={{ maxWidth: "93%", margin: "auto" }}>
              <div
                className="filterdiv couponfilterdiv"
                onClick={() => {
                  downloadZip(selectedrowRef?.current);
                }}
                style={{ width: "max-content" }}
              >
                <p>Download Images</p>
              </div>
              <div
                className="filterdiv couponfilterdiv"
                onClick={() => {
                  handleDownload(selectedrowRef?.current);
                }}
                style={{ width: "max-content", marginLeft: 15 }}
              >
                <p>Download as PDF</p>
              </div>
            </div>
            <div
              className="row printablestaffpdf"
              ref={contentRef}
              style={{
                paddingTop: 30,
                pageBreakInside: "avoid",
                breakInside: "avoid",
              }}
            >
              {Object.keys(selectedrowRef?.current).length > 0 ? (
                <table
                  class="table table-bordered"
                  style={{ maxWidth: "90%", margin: "auto" }}
                >
                  <thead>
                    <tr className="mt-3">
                      {/* <th>Sr. no</th> */}
                      <th>Question</th>
                      <th style={{ minWidth: 180 }}>Answer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(selectedrowRef?.current)?.map(
                      (item, index) => {
                        if (item !== "rowid") {
                          return (
                            <tr key={index}>
                              {/* <td>{index}</td> */}
                              <td>{item}</td>
                              <td>
                                {!checkLastSixCharacters(item) ? (
                                  selectedrowRef?.current[item]
                                ) : selectedrowRef?.current[item] ? (
                                  <Link
                                    to={selectedrowRef?.current[item]}
                                    target="_blank"
                                    className="tableviewimagediv"
                                  >
                                    <img
                                      src={selectedrowRef?.current[item]}
                                      style={{ width: 100, height: 100 }}
                                    />
                                  </Link>
                                ) : null}
                              </td>
                            </tr>
                          );
                        }
                      }
                    )}
                  </tbody>
                </table>
              ) : (
                <p>No data</p>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Details Edit Modal */}
      <Modal
        show={showeditdetailsmodal}
        onHide={() => {
          handlehideroweditdetails();
        }}
        size="md"
        className="custom-width-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 19 }}>Edit Staff Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            {selectededitrowRef.current?.length > 0 ? 
            <>

            {selectededitrowRef.current?.map((item, index) => {
                // console.log("item >>", item);
                return (
                  <>
                    {item?.status == "true" ? (
                      <div className="editdetailsdiv" key={index}>
                        <p>{item?.question}</p>
                        {item?.answertype == "textinput" ? (
                          <div
                            className="editdetailsinputdiv"
                            style={{ marginTop: 3 }}
                          >
                            <input
                              type="text"
                              className="form-control"
                              placeholder={"Enter " + item?.question}
                              value={item.value}
                              onChange={(t) => {
                                handlechangeeditdetails(index, t.target.value);
                              }}
                            />
                          </div>
                        ) : item?.answertype == "dropdown" ? (
                          <div
                                                            className="editdetailsinputdiv"
                                                            style={{ marginTop: 3 }}
                                                          >
                                                            <select
                                                              value={item?.value}
                                                              className="form-control"
                                                              onChange={(t) => {
                                                                handlechangeeditdetails(index, t.target.value);
                                                              }}
                                                            >
                                                              {item?.dropdown_data
                                                                ? JSON.parse(item?.dropdown_data)?.map(
                                                                    (ditem, dindex) => {
                                                                      return (
                                                                        <option key={dindex} value={ditem}>
                                                                          {ditem}
                                                                        </option>
                                                                      );
                                                                    }
                                                                  )
                                                                : null}
                                                            </select>
                                                            {
                                                              item?.imageIncluded == "yes" ?
                                                              item?.value == "yes" || item?.value == "Yes" ?
                                                              <div
                                                              className="editdetailsinputdiv"
                                                              style={{ marginTop: 10 }}
                                                            >
                                                              {
                                                                item?.imagefile ?
                                                                <Link to={item?.imagefile} target="_blank">
                                                                  <img src={item?.imagefile} style={{height: 80}} />
                                                                </Link>
                                                                 : null
                                                              }
                                                              <input
                                                                accept="image/*"
                                                                type="file"
                                                                className="form-control mt-2"
                                                                placeholder={"Enter " + item?.question}
                                                                // value={item.value}
                                                                onChange={(t) => {
                                                                  handleuploadeditimg(index, t.target.files[0]);
                                                                }}
                                                              />
                                                            </div>
                                                              : null
                                                              : null
                                                            }
                                                          </div>
                        ) : item?.answertype == "multi-select-dropdown" ? (
                          <div
                            className="editdetailsinputdiv"
                            style={{ marginTop: 3 }}
                          >
                            {
                              <MultiselctedDropdowncomp value={item?.value} dropdowndata={item?.dropdown_data} index={index} />
                            }
                          </div>
                        ) : item?.answertype == "numberinput" ? (
                          <div
                            className="editdetailsinputdiv"
                            style={{ marginTop: 3 }}
                          >
                            <input
                              type="number"
                              className="form-control"
                              placeholder={"Enter " + item?.question}
                              value={item.value}
                              onChange={(t) => {
                                handlechangeeditdetails(index, t.target.value);
                              }}
                            />
                          </div>
                        ) : item?.answertype == "date" ? (
                          <div
                            className="editdetailsinputdiv"
                            style={{ marginTop: 3 }}
                          >
                            <input
                              type="date"
                              className="form-control"
                              placeholder={"Enter " + item?.question}
                              value={item.value}
                              onChange={(t) => {
                                handlechangeeditdetails(index, t.target.value);
                              }}
                            />
                          </div>
                        ) : item?.answertype == "multilinetext" ? (
                          <div
                            className="editdetailsinputdiv"
                            style={{ marginTop: 3 }}
                          >
                            <textarea
                              type="text"
                              className="form-control"
                              placeholder={"Enter " + item?.question}
                              value={item.value}
                              onChange={(t) => {
                                handlechangeeditdetails(index, t.target.value);
                              }}
                              style={{ minHeight: 80 }}
                            ></textarea>
                          </div>
                        ) 
                        : item?.answertype == "image" ? (
                          <div
                            className="editdetailsinputdiv"
                            style={{ marginTop: 3 }}
                          >
                            {
                              item?.imagefile ?
                              <Link to={item?.imagefile} target="_blank">
                                <img src={item?.imagefile} style={{height: 80}} />
                              </Link>
                               : null
                            }
                            <input
                              accept="image/*"
                              type="file"
                              className="form-control mt-2"
                              placeholder={"Enter " + item?.question}
                              // value={item.value}
                              onChange={(t) => {
                                handleuploadeditimg(index, t.target.files[0]);
                              }}
                            />
                          </div>
                        ) 
                        : null}
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </>
                );
              })
            }

              <div
                  className="formsubmitbtn"
                  onClick={() => {
                    handlesubmiteditdestails();
                  }}
                >
                  <p>Submit</p>
                </div>
            </>
              
            : (
              <p>No data</p>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Staff;
